import React, { useState } from "react";
import clsx from "clsx";
import DominantSpeakerAnalyzer from "./DominantSpeakerAnalyzer";
import useParticipants from "../../../hooks/useParticipants/useParticipants";
import { getActiveRoom } from "../twilioCallUtility";
import { CALL_DATA } from "../../../constants/PublicVariables";

const ActiveSpeaker = ({ userIdentity, fromWhere, isUserAudioEnabled }) => {
    const [isUserSpeaking, setIsUserSpeaking] = useState(false);
    const remoteParticipants = useParticipants();
    const room = getActiveRoom();

    const participantObj = remoteParticipants.find((p) => p.identity === userIdentity);

    return (
        <>
            <DominantSpeakerAnalyzer
                participant={CALL_DATA.localIdentity == userIdentity ? room?.localParticipant : participantObj}
                fromWhere='overlay'
                onSpeakingChange={setIsUserSpeaking}
                isUserAudioEnabled={isUserAudioEnabled}
                isLocalUser={CALL_DATA.localIdentity == userIdentity}
            />
            {fromWhere === "gallery" ? (
                <div className={clsx("speaker-participant", isUserSpeaking && "active")}></div>
            ) : (
                isUserSpeaking && (
                    <span className='for-speaker-bg active'>
                        <span className='for-speaker-bg-in icon-mic-bar'></span>
                    </span>
                )
            )}
        </>
    );
};

export default ActiveSpeaker;
